import { isValidEvmAddress } from '@shared/helpers/web3/address';

import type { Web3Handle } from './types';

export const isWeb3Handle = (web3Handle: unknown): web3Handle is Web3Handle => {
  return (
    typeof (web3Handle as Web3Handle)?.chainId === 'number' &&
    isValidEvmAddress((web3Handle as Web3Handle)?.address)
  );
};
